import { Skeleton } from "@chakra-ui/react";
import {
  MotionGrid as Grid,
  MotionBox as Box,
  blogFadeIn as fadeIn,
} from "utils/motion";

export default function LoadingSkeleton() {
  return (
    <Grid
      templateColumns={["1fr", "repeat(2, 1fr)", "repeat(3, 1fr)"]}
      gap={6}
      mt={[6, null, 8]}
      variants={fadeIn}
      initial="hidden"
      animate="visible"
    >
      {[...Array(6)].map((_, i) => (
        <Box key={i} height="300px">
          <Skeleton
            endColor="gray.200"
            startColor="gray.100"
            height="160px"
            bg="gray.200"
            mb={["xs", null, "sm"]}
          />
          <Skeleton
            endColor="gray.200"
            startColor="gray.100"
            height="20px"
            width="95%"
            borderRadius="md"
            bg="gray.200"
            mb="6px"
          />
          <Skeleton
            endColor="gray.200"
            startColor="gray.100"
            height="20px"
            width="90%"
            bg="gray.200"
            borderRadius="md"
          />
          <Skeleton
            endColor="gray.200"
            startColor="gray.100"
            mt="xs"
            height="16px"
            width="35%"
            bg="gray.200"
            borderRadius="md"
          />
        </Box>
      ))}
    </Grid>
  );
}
